import React from "react";
import Buttoncom from "./button.component";

function Counters(props) {
  return (
    <>
      <div className="container mt-4 d-flex">
        <Buttoncom
          text="Reset"
          variant="info"
          event  = {() =>{
          props.onReset(props.index)
          }}
        />

        <Buttoncom
          text="InCrement"
          variant="primary"
          className="mx-4"
          event  = {() => {
            props.onIncre(props.index)
          }}
        />
        <p> {props.number} </p>

        <Buttoncom
          text="DeCrement"
          variant="warning"
          className="mx-4"
          event  = {() => {
            props.onDecre(props.index)
          }}
          disabled = { props.number === 0 }
        />

        <Buttoncom
          text="Delete"
          variant="danger"
          event  = {() =>{
            props.onDelete(props.index)
          }}
        />
      </div>
    </>
  );
}

export default Counters;
